import * as React from "react";
import styled, { css } from "styled-components";

import Translate from "../../common/components/Translate";
import { CompanyMembership } from "../../entities";
import { media } from "../../common/utils/style";
import { RenderMembershipFunc } from "./MembershipSection";

interface Props {
  memberships: CompanyMembership[];
  renderMembership: RenderMembershipFunc;
  limit?: number;
}

interface State {
  expanded: boolean;
}

class MembershipCardList extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      expanded: false,
    };
  }

  public onClickShowMore = (event: React.MouseEvent<HTMLElement>) => {
    event.preventDefault();
    this.setState({ expanded: true });
  };

  public render() {
    const { memberships, renderMembership, limit } = this.props;
    const { expanded } = this.state;
    return (
      <>
        <MemberCardsWrapper>
          {memberships.map(membership => {
            return (
              <MemberCard expanded={expanded} limit={limit} key={membership.id}>
                {renderMembership({ membership, key: membership.id })}
              </MemberCard>
            );
          })}
          <FillingDivs />
        </MemberCardsWrapper>
        {!expanded &&
          limit &&
          memberships.length > limit && (
            <ShowMore onClick={this.onClickShowMore}>
              <ShowMoreMessage>
                <Translate id="company.members.view_more_members" />
              </ShowMoreMessage>
            </ShowMore>
          )}
      </>
    );
  }
}

const MemberCardsWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  justify-content: space-around;
  margin: 0;
  @media ${media.large} {
    margin: 20px 0;
  }
`;

const MemberCard = styled.div`
  ${(props: { limit?: number; expanded: boolean }) =>
    props.limit && !props.expanded
      ? css`
          &:nth-child(n + ${props.limit + 1}) {
            display: none;
            @media ${media.medium} {
              display: block;
            }
          }
        `
      : css``};
`;

const ShowMore = styled.button`
  display: block;
  border-radius: 10px;
  background-color: rgb(255, 255, 255);
  border: none;
  margin: 20px auto;
  text-align: center;
  @media ${media.medium} {
    display: none;
  }
`;

const ShowMoreMessage = styled.div`
  font-weight: 400;
  font-size: 16px;
  color: rgba(33, 189, 219, 1);
`;

export default MembershipCardList;

// [NOTE(kobayang)] This is a hacked solution for centering items with keeping align-left.
// Ref: https://stackoverflow.com/a/31478004
const MaxPerLines = 6;
const FillingDivs = () => (
  <>
    {[...Array(MaxPerLines - 1)].map((_, index) => {
      return <EmptyDiv key={`hacked-empty-div-${index}`} />;
    })}
  </>
);
const EmptyDiv = styled.div`
  width: 160px;
  height: 0;
`;



// WEBPACK FOOTER //
// ./frontend/src/company_memberships/components/MembershipCardList.tsx